import { GenericTool } from "@openanalyst-ai/ui/basic-tool"
import type { ToolProps } from "@openanalyst-ai/ui/message-part"
import { PluginViewRenderer, type PluginPageView } from "./view-renderer"

type PluginViewMetadata = {
  pluginView?: {
    view?: PluginPageView
  }
}

const readonlyState = {
  pendingActionIds: new Set<string>(),
  pendingSubmitIds: new Set<string>(),
}

export function InlinePluginViewRenderer(props: ToolProps) {
  const pluginView = getPluginView(props.metadata as PluginViewMetadata)
  if (!pluginView)
    return <GenericTool tool={props.tool} status={props.status} hideDetails={props.hideDetails} input={props.input} />

  return (
    <div data-inline-plugin-view class="flex flex-col gap-4">
      <PluginViewRenderer readonly view={pluginView} state={readonlyState} onAction={() => undefined} onSubmit={() => undefined} />
    </div>
  )
}

function getPluginView(metadata: PluginViewMetadata) {
  const pluginView = metadata.pluginView
  if (!isRecord(pluginView)) return null
  const view = pluginView.view
  if (!isRecord(view)) return null
  if (typeof view.title !== "string") return null
  if (!Array.isArray(view.blocks)) return null
  return view as PluginPageView
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}
